import FullStackJSTT from './FullStackJSTT'
import SeniorJavaTS from './SeniorJavaTS'
import SeniorDevOpsTS from './SeniorDevOpsTS'
import SwiftTS from './SwiftTS'

export default { FullStackJSTT, SeniorJavaTS, SeniorDevOpsTS, SwiftTS }
